var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleArriving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.61 38.61a19 19 0 110-38 19 19 0 010 38zm11.76-20.5l-2.22-2.4a2.47 2.47 0 00-2-.8l-3.37.26v-2.22c0-.23-.15-.39-.38-.39H9.38a.39.39 0 00-.38.39v13.29c0 .57.46 1.03 1.03 1.03h1.31c.19 1.3 1.3 2.3 2.64 2.3s2.49-1 2.64-2.3h6.82c.2 1.3 1.3 2.3 2.64 2.3s2.45-1 2.65-2.3h1.76c.8 0 1.45-.65 1.45-1.45v-6.05c.04-.62-.19-1.2-.57-1.65zm-17.4 9.93c-.64 0-1.14-.54-1.14-1.15a1.15 1.15 0 012.3 0c0 .65-.54 1.15-1.15 1.15zm12.11 0a1.15 1.15 0 010-2.3c.65 0 1.15.54 1.15 1.15 0 .65-.5 1.15-1.15 1.15zm3.99-6.67h-5.14v-4.4l2.34-.2h.04c.15 0 .3.08.38.2l2.22 2.45c.08.12.16.23.16.35z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--arriving-ebd0e9f890aa09b7dc97aec9e97f6c13.svg";
export { SvgIconCircleArriving as Component };